export default {
  getNoticeTypeInfo: '/v2/notification/message/getNoticeTypeInfo/new',
  getList: '/v2/notification/find/my/messages/new',
  pullData: '/v2/shansongconfig/pull'
}
